// extracted by mini-css-extract-plugin
export default {"channels":"channels__2TFpu","channels__item":"channels__item__1fwjA","channels_visible":"channels_visible__1SnU4","fade-in":"fade-in__ouox5","fade-out":"fade-out__1LMPI"};